module.exports = __webpack_public_path__ + "img/au-act.c78bb7c0.svg";